export default __webpack_public_path__ + "static/media/water-drop-2.png";